import { isAddress, zeroAddress, type Address } from 'viem';

export const RELAUNCH_GENERATION = 'kyndo-v1';

export function readDeployment(env: Record<string, unknown>) {
  const address = (name: string): Address | undefined => {
    const value = env[name];
    return typeof value === 'string' && isAddress(value) && value.toLowerCase() !== zeroAddress
      ? value : undefined;
  };
  const fresh = env.VITE_DEPLOYMENT_GENERATION === RELAUNCH_GENERATION;
  const launchpad = fresh ? address('VITE_KYNDO_ADDRESS') : undefined;
  const factory = fresh ? address('VITE_ENGINE_FACTORY_ADDRESS') : undefined;
  const hook = fresh ? address('VITE_HOOK_ADDRESS') : undefined;
  return { launchpad, factory, hook, configured: Boolean(launchpad && factory && hook) };
}
